//import packages
import React, { useState, useEffect } from "react";
import {
  Layout,
  Table,
  Row,
  Col,
  Button,
  Modal,
  message,
  Tooltip,
} from "antd";
import styled from "styled-components";
import {
  DeleteFilled,
  EditOutlined,
  ExclamationCircleOutlined,
  DownOutlined,
  RightOutlined,
} from "@ant-design/icons";

//import other files and API function
import { lookUp } from "../../../api/LookUpAPI";
import {
  addtelecategory,
  deletetelecategory,
} from "../../../api/TelecategoryAPI";
import TelemedicineCategoryFormModal from "./TelemedicineCategoryFormModal";
import UserRolesAndRightsHOComponent from "../../../components/UserRolesAndRightsHOComponent/UserRolesAndRightsHOComponent";
import authorization from "../../../auth/authorization";
import {
  StyledComponentWrapper,
  Title,
  TableHeader,
  ExpandButton,
  ExpandedDetails,
  DetailItem,
  DetailLabel,
  DetailValue,
} from "../../SharedStyles";

const { confirm } = Modal;
const { Content } = Layout;

const TelemedicineComponentWrapper = styled(StyledComponentWrapper)`
  max-width: 980px;
  margin: 24px auto;
  @media (max-width: 1200px) {
    max-width: 720px;
  }
  @media (max-width: 788px), (max-width: 922px) {
    max-width: 580px;
  }
  @media (max-width: 720px) {
    max-width: 320px;
  }
`;

const TableWrapper = styled(TelemedicineComponentWrapper)`
  min-height: calc(100vh - 120px);
`;

const TeleMedicineComponent = (props) => {
  const { userType } = props;
  const [Telecategory, setTelecategory] = useState([]);
  const [editId, setEditId] = useState("");
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);

  const [columns, setColumns] = useState([
    { title: "Name", dataIndex: "name", key: "name", width: 220, ellipsis: true },
    { title: "Slug", dataIndex: "slug", key: "slug", width: 180, ellipsis: true },
    { 
      title: "CEV Eligible", 
      dataIndex: "oneClickPrescribeEligible", 
      key: "oneClickPrescribeEligible", 
      width: 130,
      align: "center",
      render: (eligible) => (eligible ? "✅" : "🚫"),
    },
  ]);

  const handleEdit = (id) => {
    setEditId(id);
    setIsFormModalVisible(true);
  };

  const handleAdd = () => {
    setEditId("");
    setIsFormModalVisible(true);
  };

  const closeFormModal = () => {
    setEditId("");
    setIsFormModalVisible(false);
  };

  const updateColumnsInListing = () => {
    const clonnedColumns = columns.slice(0);
    if (authorization.isAllowed(userType, "updateTeleMedicineCategory")) {
      clonnedColumns.push({
        title: "Edit",
        dataIndex: "",
        key: "e",
        width: 80,
        align: "center",
        fixed: "right",
        render: (_, record) => (
          <Button
            shape="circle"
            icon={<EditOutlined />}
            onClick={(event) => {
              event.stopPropagation();
              handleEdit(record.key);
            }}
          />
        ),
      });
    }
    if (authorization.isAllowed(userType, "deleteTeleMedicineCategory")) {
      clonnedColumns.push({
        title: "Delete",
        dataIndex: "",
        key: "x",
        width: 80,
        align: "center",
        fixed: "right",
        render: (state, record) => (
          <Button
            shape="circle"
            icon={<DeleteFilled />}
            onClick={(event) => {
              event.stopPropagation();
              showDeleteConfirmation(state, record.key);
            }}
          />
        ),
      });
    }
    setColumns([...clonnedColumns]);
  };

  const fetchTelecategory = () => {
    lookUp("tele-medicine-category").then((res) => {
      if (res.data && res.data.payload) {
        const stateData = res.data.payload.map((eachState) => ({
          ...eachState,
          key: eachState._id,
        }));
        setTelecategory(stateData);
      }
    });
  };

  useEffect(() => {
    fetchTelecategory();
  }, []);

  const initCallsForComponent = () => {
    updateColumnsInListing();
  };

  // eslint-disable-next-line
  useEffect(initCallsForComponent, [userType]);

  const onAddingState = (telemedicineCategoryDetails) => {
    addtelecategory(telemedicineCategoryDetails)
      .then((res) => {
        const { data } = res;
        if (data && data.success) {
          message.success("Successfully added Telemedicine Category");
          closeFormModal();
        } else {
          if (data && data.message) {
            message.error(data.message);
          } else {
            message.error(
              "Unable to Add Telemedicine Catgeory. Please try again!"
            );
          }
        }
        fetchTelecategory();
      })
      .catch((error) => {
        console.log("================== error ========================", error);
        const { response } = error;
        if (response) {
          const { data } = response;
          if (data && data.message) {
            message.error(data.message);
          } else {
            message.error(
              "Unable to Add Telemedicine Catgeory. Please try again!"
            );
          }
        } else {
          message.error(
            "Unable to Add Telemedicine Category. Please try again!"
          );
        }
      });
  };

  const onDeletingState = (stateId) => {
    deletetelecategory(stateId)
      .then((res) => {
        const { status } = res;
        if (status && status === 204) {
          message.success("Successfully deleted Telemedicine Category");
          closeFormModal();
        } else {
          const { data } = res;
          if (data && data.success) {
            message.success("Successfully deleted Telemedicine Category");
            closeFormModal();
          } else {
            if (data && data.message) {
              message.error(data.message);
            } else {
              message.error(
                "Unable to delete Telemedicine Catgeory. Please try again!"
              );
            }
          }
        }
        fetchTelecategory();
      })
      .catch((error) => {
        console.log(
          "================== delete telemedicine category error ========================",
          error
        );
        const { response } = error;
        if (response) {
          const { data } = response;
          if (data && data.message) {
            message.error(data.message);
          } else {
            message.error(
              "Unable to Delete Telemedicine Catgeory. Please try again!"
            );
          }
        } else {
          message.error(
            "Unable to Delete Telemedicine Category. Please try again!"
          );
        }
      });
  };

  const showDeleteConfirmation = (state, stateId) => {
    confirm({
      title: `Do you want to delete ${state.name} telemedicine category?`,
      icon: <ExclamationCircleOutlined />,
      onOk: () => {
        onDeletingState(stateId);
      },
      onCancel() {},
    });
  };

  const renderExpandedRow = (record) => (
    <ExpandedDetails>
      <DetailItem>
        <DetailLabel>StackAI Project ID (Initial)</DetailLabel>
        <DetailValue>{record.stackAIProjectId || "--"}</DetailValue>
      </DetailItem>
      <DetailItem>
        <DetailLabel>StackAI Project ID (Renewal)</DetailLabel>
        <DetailValue>{record.renewalStackAIProjectId || "--"}</DetailValue>
      </DetailItem>
      <DetailItem>
        <DetailLabel>CDS Options</DetailLabel>
        <DetailValue>
          {record.CDS && record.CDS.length ? record.CDS.join(", ") : "--"}
        </DetailValue>
      </DetailItem>
    </ExpandedDetails>
  );

  return (
    <>
      <Content>
        <TelemedicineCategoryFormModal
          open={isFormModalVisible}
          editId={editId}
          userType={userType}
          onCancel={closeFormModal}
          addState={onAddingState}
          afterEdit={closeFormModal}
          fetchTelecategoryAfterUpdate={fetchTelecategory}
        />
        <TableWrapper>
          <TableHeader>
            <Title level={2}>Telemedicine Categories</Title>
            {authorization.isAllowed(userType, "createTeleMedicineCategory") ? (
              <Button type="primary" size="large" onClick={handleAdd}>
                Add
              </Button>
            ) : null}
          </TableHeader>
          <Row>
            <Col span={24}>
              <Table
                columns={columns}
                dataSource={Telecategory}
                expandable={{
                  expandedRowRender: renderExpandedRow,
                  expandRowByClick: true,
                  expandIcon: ({ expanded, onExpand, record }) => (
                    <Tooltip title={expanded ? "Collapse details" : "Expand details"}>
                      <ExpandButton
                        shape="circle"
                        size="small"
                        type="text"
                        icon={expanded ? <DownOutlined /> : <RightOutlined />}
                        onClick={(event) => {
                          event.stopPropagation();
                          onExpand(record, event);
                        }}
                      />
                    </Tooltip>
                  ),
                }}
                pagination={false}
                scroll={{ x: 760, y: "calc(100vh - 290px)" }}
                tableLayout="fixed"
              />
            </Col>
          </Row>
        </TableWrapper>
      </Content>
    </>
  );
};

export default UserRolesAndRightsHOComponent(TeleMedicineComponent);
